// The full X12 GS01 / AK101 Functional Identifier Code list (DE 479) —
// shared by the envelope GS segment and the 997's AK1 segment, which both
// identify a functional group's transaction set type. Transcribed from the
// reference document "00 - Envelope and Common Qualifiers.txt".
//
// Each entry's `label` is the short name (used for the coded value's inline
// display); see dictionary/types.ts's `CodeListEntry` for the shape.

import type {CodeListEntry} from './types';

export const FUNCTIONAL_IDENTIFIER_CODES: CodeListEntry[] = [
  {code: 'IN', label: 'Invoice Information (810)'},
  {code: 'RQ', label: 'Request for Quotation (840)'},
  {code: 'RR', label: 'Response to Request for Quotation (843)'},
  {code: 'PO', label: 'Purchase Order (850)'},
  {code: 'PR', label: 'Purchase Order Acknowledgment (855)'},
  {code: 'FA', label: 'Functional Acknowledgment (997)'},
  {code: 'IM', label: 'Motor Carrier Freight Details and Invoice (210)'},
  {code: 'CA', label: 'Product Transfer Account Adjustment (844)'},
  {code: 'PA', label: 'Price Authorization Acknowledgment/Status (845)'},
  {code: 'SH', label: 'Ship Notice/Manifest (856)'},
  {code: 'PT', label: 'Product Transfer and Resale Report (867)'},
];
